
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { useToast } from '@/hooks/use-toast';
import ReleaseCardImage from './ReleaseCardImage';
import ReleaseCardContent from './ReleaseCardContent';
import ReleaseCardMenu from './ReleaseCardMenu';

interface ReleaseCardProps {
  id: string;
  title: string;
  coverArt: string;
  releaseDate: string;
  streams: number;
  status?: 'released' | 'scheduled' | 'draft';
  platforms?: string[];
  className?: string;
}

const ReleaseCard: React.FC<ReleaseCardProps> = ({
  id,
  title,
  coverArt,
  releaseDate,
  streams,
  status = 'released',
  platforms = ['Spotify', 'Apple Music', 'Amazon'],
  className,
}) => {
  const { toast } = useToast();
  
  const handlePlay = () => {
    toast({
      title: "Playing track",
      description: `Now playing ${title}`,
    });
  };
  
  const handleShare = () => {
    toast({
      title: "Link copied",
      description: "Release link copied to clipboard",
    });
  };
  
  return (
    <Card
      className={cn(
        "neo-card overflow-hidden group hover:shadow-hover transition-all duration-300",
        className
      )}
    >
      <CardContent className="p-0">
        <ReleaseCardImage 
          coverArt={coverArt}
          title={title}
          status={status}
          onPlay={handlePlay}
        />
        
        <div className="flex justify-between items-start absolute top-2 right-2">
          <ReleaseCardMenu 
            id={id}
            onPlay={handlePlay}
            onShare={handleShare}
          />
        </div>
        
        <ReleaseCardContent
          id={id}
          title={title}
          releaseDate={releaseDate}
          streams={streams}
          platforms={platforms}
          onShare={handleShare}
        />
      </CardContent>
    </Card>
  );
};

export default ReleaseCard;
